const USER_TYPES = {
    HUMAN:'human',
    BOT:'bot',
    AGENT:'agent',
};

export default USER_TYPES;